import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import axios from "axios";

import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import Get from "../../Get";

function ArticulosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_ARTICULOS = import.meta.env.VITE_URL_ARTICULOS;
  const URL_INVENTARIOS = import.meta.env.VITE_URL_INVENTARIOS;
  const URL_LINEAS = import.meta.env.VITE_URL_LINEAS;
  const URL_MARCAS = import.meta.env.VITE_URL_MARCAS;
  const URL_FAMILIAS = import.meta.env.VITE_URL_FAMILIAS;
  const URL_COLECCIONES = import.meta.env.VITE_URL_COLECCIONES;
  const URL_PROVEEDORES = import.meta.env.VITE_URL_PROVEEDORES;
  const URL_COLORES = import.meta.env.VITE_URL_COLORES;
  const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;
  const URL_ARTICULOS_PROPORCION =
    import.meta.env.VITE_URL_ARTICULOS_PROPORCION;
  const URL_FILEPOST = import.meta.env.VITE_URL_UPPROFILE;

  const [codigo, setCodigo] = useState("");
  const [nombre, setNombre] = useState("");
  const [piezasPorCaja, setPiezasPorCaja] = useState("");
  const [costoUSD, setCostoUSD] = useState(0);
  const [costoMX, setCostoMX] = useState(0);
  const [venta, setVenta] = useState(0);
  const [listaPrecioPieza, setListaPrecioPieza] = useState("");
  const [listaPrecioCorrida, setListaPrecioCorrida] = useState("");
  const [listaPrecioPaquete, setListaPrecioPaquete] = useState("");
  const [listaPrecioCaja, setListaPrecioCaja] = useState("");
  const [listaPrecioRebajas, setListaPrecioRebajas] = useState("");
  const [codigoSAT, setCodigoSAT] = useState("NA");
  const [codigoUnidad, setCodigoUnidad] = useState("PZ");
  const [observaciones, setObservaciones] = useState("NA");
  const [lineas, setLineas] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [colecciones, setColecciones] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [precioEsp, setPrecioEsp] = useState("");
  const [ano, setAno] = useState("");
  const [EAN, setEAN] = useState("");
  const [selectedLinea, setSelectedLinea] = useState("");
  const [selectedMarca, setSelectedMarca] = useState("");
  const [selectedFamilia, setSelectedFamilia] = useState("");
  const [selectedColeccion, setSelectedColeccion] = useState("");
  const [selectedProveedor, setSelectedProveedor] = useState("");

  // For "Add New" toggle and input state
  const [isAddingLinea, setIsAddingLinea] = useState(false);
  const [newLineaName, setNewLineaName] = useState("");

  const [isAddingMarca, setIsAddingMarca] = useState(false);
  const [newMarcaName, setNewMarcaName] = useState("");

  const [isAddingFamilia, setIsAddingFamilia] = useState(false);
  const [newFamiliaName, setNewFamiliaName] = useState("");

  const [isAddingColeccion, setIsAddingColeccion] = useState(false);
  const [newColeccionName, setNewColeccionName] = useState("");

  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [customSizeOrder, setCustomSizeOrder] = useState([]);

  const [modalColores, setModalColores] = useState(false);
  const toggleColores = () => setModalColores(!modalColores);
  const [arrayColores, setArrayColores] = useState([]);

  const [modalTallas, setModalTallas] = useState(false);
  const toggleTallas = () => setModalTallas(!modalTallas);
  const [arrayTallas, setArrayTallas] = useState([]);
  const [eans, setEans] = useState([]);

  const [amounts, setAmounts] = useState([]);
  const [validaBoton, setValidaBoton] = useState(true);

  // Photo upload states
  const [file, setFile] = useState(null);
  const [photoPreview, setPhotoPreview] = useState("");
  const [modalFoto, setModalFoto] = useState(false);

  const toggleFoto = () => {
    setModalFoto(!modalFoto);
  };

  // Function to clear photo selection
  const clearPhoto = () => {
    setFile(null);
    setPhotoPreview("");
  };

  // Function to handle file selection and create preview
  const handleFileSelect = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      // Validate file type
      if (!selectedFile.type.startsWith("image/")) {
        Swal.fire({
          icon: "error",
          title: "Tipo de archivo inválido",
          text: "Por favor seleccione un archivo de imagen válido (JPG, PNG, etc.)",
        });
        e.target.value = ""; // Clear the input
        return;
      }

      // Validate file size (limit to 5MB)
      if (selectedFile.size > 5 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "Archivo muy grande",
          text: "El archivo no debe superar los 5MB",
        });
        e.target.value = ""; // Clear the input
        return;
      }

      setFile(selectedFile);

      // Create preview URL
      const reader = new FileReader();
      reader.onload = (e) => {
        setPhotoPreview(e.target.result);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  let hoy = new Date();
  hoy.setDate(hoy.getDate() - 3650);
  const year = hoy.getFullYear();
  const years = Array.from(new Array(40), (val, index) => index + year);

  const [lastChanged, setLastChanged] = useState(null);


  // useEffect to update EAN codes when codigo changes (autobarcode logic)
  useEffect(() => {
    if (codigo && amounts.length > 0) {
      // Update EAN for each amount entry that has a quantity > 0
      const updatedAmounts = amounts.map((entry) => {
        if (entry.cantidad > 0) {
          const newEAN = generateEAN(entry.colorId, entry.sizeId);
          return {
            ...entry,
            ean: newEAN || entry.ean, // Keep existing EAN if not generated
          };
        }
        return entry;
      });
      setAmounts(updatedAmounts);
    }
  }, [codigo]);

  useEffect(() => {
    axios
      .get(URL_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allLineas = res.data;
        setLineas(allLineas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_MARCAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allMarcas = res.data;
        setMarcas(allMarcas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_FAMILIAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allFamilias = res.data;
        setFamilias(allFamilias);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLECCIONES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColecciones = res.data;
        setColecciones(allColecciones);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(`${URL_PROVEEDORES}Tipo/China`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColores = res.data;
        setColores(allColores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);

        const customeSizeOrder = allTallas
          .map((t) => t.name)
        setCustomSizeOrder(customeSizeOrder);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  function coloresSeleccionados(checked, color) {
    if (checked) {
      setArrayColores([...arrayColores, { id: color._id, name: color.name }]);
    } else {
      const values = [...arrayColores];
      // Handle both cases: color object with _id (from original list) or selectedColor object with id (from selected list)
      const colorId = color._id || color.id;
      const indexToRemove = values.findIndex((t) => t.id === colorId);

      if (indexToRemove !== -1) {
        values.splice(indexToRemove, 1);
        setArrayColores(values);
      }
    }
  }

  function tallasSeleccionados(checked, talla) {
    if (checked) {
      setArrayTallas([...arrayTallas, { id: talla._id, name: talla.name }]);
    } else {
      const values = [...arrayTallas];
      // Handle both cases: talla object with _id (from original list) or selectedTalla object with id (from selected list)
      const tallaId = talla._id || talla.id;
      const indexToRemove = values.findIndex((t) => t.id === tallaId);

      if (indexToRemove !== -1) {
        values.splice(indexToRemove, 1);
        setArrayTallas(values);
      }
    }
  }

  // Función para sanitizar el código EAN/barcode
  // Elimina espacios, acentos y caracteres especiales que causan problemas con escáneres
  const sanitizeBarcode = (code) => {
    if (!code) return "";
    return code
      .toString()
      .normalize("NFD") // Descompone caracteres acentuados
      .replace(/[\u0300-\u036f]/g, "") // Elimina los acentos
      .replace(/[^a-zA-Z0-9]/g, "") // Solo permite alfanuméricos (sin guiones ni puntos para compatibilidad con escáneres)
      .toUpperCase()
      .trim();
  };

  // Function to generate EAN code (autobarcode logic)
  const generateEAN = (colorId, tallaId) => {
    if (codigo && colorId && tallaId) {
      // Search in selected arrays first, then in full arrays
      let colorPre = arrayColores.find(c => c.id === colorId)?.prefijo;
      if (!colorPre) {
        colorPre = colores.find(c => c._id === colorId)?.prefijo;
      }

      let tallaName = arrayTallas.find(t => t.id === tallaId)?.name;
      if (!tallaName) {
        tallaName = tallas.find(t => t._id === tallaId)?.name;
      }

      if (colorPre && tallaName) {
        // Sanitizar todos los componentes para evitar caracteres problemáticos
        const codigoSanitizado = sanitizeBarcode(codigo);
        const colorPreSanitizado = sanitizeBarcode(colorPre);
        const tallaSanitizada = sanitizeBarcode(tallaName);
        const ean = `${codigoSanitizado}${colorPreSanitizado}${tallaSanitizada}`;
        return ean;
      }
    }
    return "";
  };

  const handleEanChange = (sizeId, colorId, value) => {
    setEans((prev) => {
      const existing = prev.find(
        (entry) => entry.sizeId === sizeId && entry.colorId === colorId
      );
      if (existing) {
        return prev.map((entry) =>
          entry.sizeId === sizeId && entry.colorId === colorId
            ? { ...entry, ean: value }
            : entry
        );
      } else {
        return [...prev, { sizeId, colorId, ean: value }];
      }
    });
  };

  // Enhanced handleInputChange with autobarcode logic
  const handleInputChange = (sizeId, colorId, value, fieldType) => {
    const updatedAmounts = [...amounts];
    const existingEntryIndex = updatedAmounts.findIndex(
      (entry) => entry.sizeId === sizeId && entry.colorId === colorId
    );

    if (existingEntryIndex !== -1) {
      // Update existing entry
      if (fieldType === "amount") {
        updatedAmounts[existingEntryIndex].cantidad = value;
        // Auto-generate EAN when amount is entered and codigo exists
        if (codigo && value > 0) {
          updatedAmounts[existingEntryIndex].ean = generateEAN(colorId, sizeId);
        }
      } else if (fieldType === "ean") {
        updatedAmounts[existingEntryIndex].ean = value;
      }
    } else {
      // Create new entry with default values
      const autoGeneratedEAN = (fieldType === "amount" && codigo && value > 0)
        ? generateEAN(colorId, sizeId)
        : "";

      const newEntry = {
        sizeId: sizeId,
        colorId: colorId,
        tallas: sizeId,
        colores: colorId,
        cantidad: fieldType === "amount" ? value : 0,
        ean: fieldType === "ean" ? value : autoGeneratedEAN,
      };
      updatedAmounts.push(newEntry);
    }

    setAmounts(updatedAmounts);

    // Calculate total for piezasPorCaja (only using the cantidad values)
    const totalAmount = updatedAmounts.reduce(
      (acc, curr) => acc + (parseFloat(curr.cantidad) || 0),
      0
    );

    setPiezasPorCaja(totalAmount);
  };

  // Validation function for required fields
  function validateRequiredFields() {
    const missingFields = [];

    if (!codigo.trim()) missingFields.push("Número de Modelo");
    if (!nombre.trim()) missingFields.push("Nombre");
    if (!costoMX) missingFields.push("Costo MX");
    if (!venta) missingFields.push("Venta");
    if ((!selectedLinea || selectedLinea === "0") && (!isAddingLinea || !newLineaName.trim())) missingFields.push("Línea");
    if ((!selectedMarca || selectedMarca === "0") && (!isAddingMarca || !newMarcaName.trim())) missingFields.push("Marca");
    if ((!selectedFamilia || selectedFamilia === "0") && (!isAddingFamilia || !newFamiliaName.trim())) missingFields.push("Familia");
    if ((!selectedColeccion || selectedColeccion === "0") && (!isAddingColeccion || !newColeccionName.trim())) missingFields.push("Colección");
    if (!selectedProveedor || selectedProveedor === "0") missingFields.push("Proveedor");
    if (!ano || ano === "0") missingFields.push("Año");
    if (!EAN.trim()) missingFields.push("EAN");
    if (arrayColores.length === 0) missingFields.push("Al menos un color");
    if (arrayTallas.length === 0) missingFields.push("Al menos una talla");
    if (!amounts.some((entry) => entry.cantidad > 0)) missingFields.push("Al menos una cantidad en la proporción");

    return missingFields;
  }

  const saveArticulos = async (event) => {
    event.preventDefault();
    setValidaBoton(false);

    // Validate required fields first
    const missingFields = validateRequiredFields();
    if (missingFields.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Campos requeridos",
        text: `Los siguientes campos son obligatorios: ${missingFields.join(", ")}`,
        showConfirmButton: true,
      });
      setValidaBoton(true);
      return;
    }

    const amountsConDatos = amounts.filter(
      (a) => parseFloat(a.cantidad) > 0 || (a.ean && a.ean.trim() !== "")
    );
    const arrayColoresOfIds = [...new Set(amountsConDatos.map((a) => a.colorId))];
    const arrayTallasOfIds = [...new Set(amountsConDatos.map((a) => a.sizeId))];

    let totalProporcion = amountsConDatos.length;

    // Validate that all entries with cantidad have EAN
    const entriesWithQuantityButNoEAN = amounts.filter(
      (entry) => (parseFloat(entry.cantidad) || 0) > 0 && (!entry.ean || entry.ean.trim() === "")
    );

    if (entriesWithQuantityButNoEAN.length > 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Todos los registros con cantidad deben tener código de barras (EAN)!",
      });
      setValidaBoton(true);
      return;
    }

    if (piezasPorCaja == 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes agregar la proporcion de piezas por caja!",
      });
      setValidaBoton(true);
      return;
    }

    try {
      // Create any new items if needed
      let finalLineaId = selectedLinea;
      let finalMarcaId = selectedMarca;
      let finalFamiliaId = selectedFamilia;
      let finalColeccionId = selectedColeccion;
      let finalProveedorId = selectedProveedor;

      // Check if we need to create a new Linea
      if (isAddingLinea && newLineaName.trim()) {
        try {
          const lineaResponse = await axios.post(
            URL_LINEAS,
            { name: newLineaName.trim() },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          finalLineaId = lineaResponse.data._id;

          // Update the lineas list for future reference
          setLineas((prevLineas) => [...prevLineas, lineaResponse.data]);
        } catch (error) {
          console.error("Error creating new linea:", error);
          Swal.fire({
            icon: "error",
            title: "Error al crear nueva Linea",
            text: error.response?.data?.message || error.response?.data?.error || "Error desconocido",
          });
          setValidaBoton(true);
          return;
        }
      }

      // Check if we need to create a new Marca
      if (isAddingMarca && newMarcaName.trim()) {
        try {
          const marcaResponse = await axios.post(
            URL_MARCAS,
            { name: newMarcaName.trim() },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          finalMarcaId = marcaResponse.data._id;

          // Update the marcas list for future reference
          setMarcas((prevMarcas) => [...prevMarcas, marcaResponse.data]);
        } catch (error) {
          console.error("Error creating new marca:", error);
          Swal.fire({
            icon: "error",
            title: "Error al crear nueva Marca",
            text: error.response?.data?.message || error.response?.data?.error || "Error desconocido",
          });
          setValidaBoton(true);
          return;
        }
      }

      // Check if we need to create a new Familia
      if (isAddingFamilia && newFamiliaName.trim()) {
        try {
          const familiaResponse = await axios.post(
            URL_FAMILIAS,
            { name: newFamiliaName.trim() },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          finalFamiliaId = familiaResponse.data._id;

          // Update the familias list for future reference
          setFamilias((prevFamilias) => [
            ...prevFamilias,
            familiaResponse.data,
          ]);
        } catch (error) {
          console.error("Error creating new familia:", error);
          Swal.fire({
            icon: "error",
            title: "Error al crear nueva Familia",
            text: error.response?.data?.message || error.response?.data?.error || "Error desconocido",
          });
          setValidaBoton(true);
          return;
        }
      }

      // Check if we need to create a new Coleccion
      if (isAddingColeccion && newColeccionName.trim()) {
        try {
          const coleccionResponse = await axios.post(
            URL_COLECCIONES,
            { name: newColeccionName.trim() },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          finalColeccionId = coleccionResponse.data._id;

          // Update the colecciones list for future reference
          setColecciones((prevColecciones) => [
            ...prevColecciones,
            coleccionResponse.data,
          ]);
        } catch (error) {
          console.error("Error creating new coleccion:", error);
          Swal.fire({
            icon: "error",
            title: "Error al crear nueva Colección",
            text: error.response?.data?.message || error.response?.data?.error || "Error desconocido",
          });
          setValidaBoton(true);
          return;
        }
      }

      // Now create the article with the final IDs
      await axios
        .post(
          URL_ARTICULOS,
          {
            codigo,
            nombre,
            piezasPorCaja,
            costoUSD: 0,
            costoMX,
            venta,
            utilidadP: 0,
            utilidadM: 0,
            listaPrecioPieza: listaPrecioPieza,
            listaPrecioCorrida: listaPrecioCorrida,
            listaPrecioPaquete: listaPrecioPaquete,
            listaPrecioCaja: listaPrecioCaja,
            listaPrecioRebajas: listaPrecioRebajas,
            observaciones,
            lineas: finalLineaId,
            marcas: finalMarcaId,
            familias: finalFamiliaId,
            colecciones: finalColeccionId,
            proveedores: finalProveedorId,
            ano,
            EAN,
            precioEsp,
            colores: arrayColoresOfIds,
            tallas: arrayTallasOfIds,
            codigoSAT,
            codigoUnidad,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )

        .then(async (data) => {
          const createdArticleId = data.data._id;

          // Upload photo if exists
          if (file) {
            try {
              const formData = new FormData();
              formData.append("file", file);
              formData.append("articulo", createdArticleId);

              await axios.post(URL_FILEPOST, formData, {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              });

              // Log photo upload
              await axios.post(
                URL_LOGS,
                {
                  tipo: "Foto Articulo",
                  detalle: `${nombre} ${codigo}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              );
            } catch (photoError) {
              console.error("Error uploading photo:", photoError);
              // Continue with article creation even if photo upload fails
            }
          }

          amountsConDatos.map((a) => {
            axios
              .post(
                URL_ARTICULOS_PROPORCION,
                {
                  articulos: data.data._id,
                  cantidad: a.cantidad,
                  colores: a.colorId,
                  tallas: a.sizeId,
                  EAN: a.ean,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalProporcion = totalProporcion - 1;
                if (totalProporcion == 0) {
                  axios.post(
                    URL_LOGS,
                    {
                      tipo: "Crear Modelo",
                      detalle: `${nombre} ${codigo}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  );

                  const successMessage = file
                    ? "¡Artículo creado con éxito y foto subida!"
                    : "¡Artículo creado con éxito!";

                  Swal.fire("¡Excelente!", successMessage, "success");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                }
              })
              .catch((error) => {
                console.log(error);
                setValidaBoton(true);
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
                });
              });
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
      });
      console.log(error);
    }
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_articulos ? (
        <div
          className="card container col 10"
          style={{ paddingLeft: "30px", paddingRight: "30px" }}
        >
          <h3 align="center">Nuevo Modelo</h3>
          {/* <Get/> */}
          <Form onSubmit={saveArticulos}>
            <Row>
              <Col md={3}>
                <Label>Numero de Modelo</Label>
                <Input
                  type="text"
                  placeholder="Codigo"
                  value={codigo}
                  required
                  onChange={(e) => {
                    setCodigo(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Nombre</Label>
                <Input
                  type="text"
                  placeholder="Nombre"
                  value={nombre}
                  required
                  onChange={(e) => {
                    setNombre(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
                <Label>Piezas Por Caja</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={piezasPorCaja}
                  required
                  disabled
                />
              </Col>
              <Col md={3}>
                <Label>Código de barras</Label>
                <Input
                  type="text"
                  placeholder="Código de barras"
                  value={EAN}
                  required
                  onChange={(e) => {
                    setEAN(e.target.value);
                  }}
                />
              </Col>
            </Row>

            <Row>
            
              <Col md={3}>
                <Label>Costo MX</Label>
                <Input
                  type="number"
                  placeholder="Costo MX"
                  value={costoMX}
                  required
                  onChange={(e) => {
                    setCostoMX(e.target.value);
                  }}
                />
              </Col>

            
              <Col md={3}>
                <Label>Venta</Label>
                <Input
                  type="number"
                  placeholder="Venta"
                  value={venta}
                  required
                  onChange={(e) => {
                    setVenta(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
                <Label>Observaciones</Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Codigo SAT</Label>
                <Input
                  type="select"
                  placeholder="CodigoSAT"
                  value={codigoSAT}
                  required
                  onChange={(e) => {
                    setCodigoSAT(e.target.value);
                  }}
                >
                 <option value="">Selecciona</option>
                  <option value="52121500">52121500 Cobija</option>
                  <option value="53101500">53101500 Pantalones de deporte, pantalones y pantalones cortos</option>
                  <option value="53101502">53101502 Pantalon Hombre</option>
                  <option value="53101504">53101504 Pantalones largos o cortos o pantalonetas para mujer</option>
                  <option value="53101600">53101600 Faldas y blusas, top</option>
                  <option value="53101602">53101602 Camisas Hombre</option>
                  <option value="53101604">53101604 Camisas o blusas para mujer - Playeras de mujer</option>
                  <option value="53101700">53101700 Suéteres</option>
                  <option value="53101704">53101704 Sweater Mujer</option>
                  <option value="53101800">53101800 Abrigos y chaquetas</option>
                  <option value="53101804">53101804 Chamarras Mujer</option>
                  <option value="53101904">53101904 Conjunto</option>
                  <option value="53102002">53102002 Vestidos o faldas o saris o kimonos para para mujer</option>
                  <option value="53102800">53102800 Trajes de Baño</option>
                  <option value="53102802">53102802 Vestidos de baño para mujer</option>
                  <option value="53102901">53102901 Ropa atlética para mujer</option>
                  <option value="53103100">53103100 Chalecos</option>
                  <option value="53111502">53111502 Botas para mujer</option>
                  <option value="53111602">53111602 Zapatos para mujer</option>
                  <option value="53121601">53121601 Bolsos o carteras</option>

                </Input>
              </Col>
              <Col md={3}>
                <Label>Codigo Unidad</Label>
                <Input
                  type="string"
                  placeholder="CodigoUnidad"
                  value={codigoUnidad}
                  required
                  onChange={(e) => {
                    setCodigoUnidad(e.target.value);
                  }}
                />
              </Col>

               <Col md={3}>
                <Label>Precio Especial</Label>
                <Input
                  type="select"
                  value={precioEsp}
                  required
                  onChange={(e) => {
                    setPrecioEsp(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </Col>
            </Row>
            <Row>
              {/* Linea */}
              <Col md={3} className="mb-3">
                <Label className="mr-sm-2">Linea</Label>
                <div className="d-flex align-items-center">
                  {!isAddingLinea ? (
                    <>
                      <div style={{ width: "calc(100% - 40px)" }}>
                        <Input
                          type="select"
                          value={selectedLinea}
                          required
                          onChange={(e) => {
                            setSelectedLinea(e.target.value);
                          }}
                          style={{ width: "100%" }}
                        >
                          <option value="0">Selecciona una Linea</option>
                          {lineas
                            .sort((a, b) => (a.name > b.name ? 1 : -1))
                            .map((a) => {
                              return <option key={a._id} value={a._id}>{a.name}</option>;
                            })}
                        </Input>
                      </div>
                      <Button
                        color="success"
                        size="sm"
                        type="button"
                        style={{
                          marginLeft: "10px",
                          borderRadius: "4px",
                          padding: "6px 10px",
                        }}
                        onClick={() => {
                          setIsAddingLinea(true);
                        }}
                      >
                        <i className="fas fa-plus"></i>
                      </Button>
                    </>
                  ) : (
                    <>
                      <div style={{ width: "calc(100% - 40px)" }}>
                        <Input
                          type="text"
                          value={newLineaName}
                          required
                          placeholder="Nueva Linea"
                          onChange={(e) => {
                            setNewLineaName(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && newLineaName.trim()) {
                              setIsAddingLinea(false);
                            }
                          }}
                          style={{ width: "100%" }}
                        />
                      </div>
                      <Button
                        color="secondary"
                        size="sm"
                        type="button"
                        style={{
                          marginLeft: "10px",
                          borderRadius: "4px",
                          padding: "6px 10px",
                        }}
                        onClick={() => {
                          setIsAddingLinea(false);
                          setNewLineaName("");
                        }}
                      >
                        <i className="fas fa-times"></i>
                      </Button>
                    </>
                  )}
                </div>
              </Col>

              {/* Marca */}
              <Col md={3} className="mb-3">
                <Label className="mr-sm-2">Marca</Label>
                <div className="d-flex align-items-center">
                  {!isAddingMarca ? (
                    <>
                      <div style={{ width: "calc(100% - 40px)" }}>
                        <Input
                          type="select"
                          value={selectedMarca}
                          required
                          onChange={(e) => {
                            setSelectedMarca(e.target.value);
                          }}
                          style={{ width: "100%" }}
                        >
                          <option value="0">Selecciona una Marca</option>
                          {marcas
                            .sort((a, b) => (a.name > b.name ? 1 : -1))
                            .map((a) => {
                              return <option key={a._id} value={a._id}>{a.name}</option>;
                            })}
                        </Input>
                      </div>
                      <Button
                        color="success"
                        size="sm"
                        type="button"
                        style={{
                          marginLeft: "10px",
                          borderRadius: "4px",
                          padding: "6px 10px",
                        }}
                        onClick={() => {
                          setIsAddingMarca(true);
                        }}
                      >
                        <i className="fas fa-plus"></i>
                      </Button>
                    </>
                  ) : (
                    <>
                      <div style={{ width: "calc(100% - 40px)" }}>
                        <Input
                          type="text"
                          value={newMarcaName}
                          required
                          placeholder="Nueva Marca"
                          onChange={(e) => {
                            setNewMarcaName(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && newMarcaName.trim()) {
                              setIsAddingMarca(false);
                            }
                          }}
                          style={{ width: "100%" }}
                        />
                      </div>
                      <Button
                        color="secondary"
                        size="sm"
                        type="button"
                        style={{
                          marginLeft: "10px",
                          borderRadius: "4px",
                          padding: "6px 10px",
                        }}
                        onClick={() => {
                          setIsAddingMarca(false);
                          setNewMarcaName("");
                        }}
                      >
                        <i className="fas fa-times"></i>
                      </Button>
                    </>
                  )}
                </div>
              </Col>

              {/* Familia */}
              <Col md={3} className="mb-3">
                <Label className="mr-sm-2">Familia</Label>
                <div className="d-flex align-items-center">
                  {!isAddingFamilia ? (
                    <>
                      <div style={{ width: "calc(100% - 40px)" }}>
                        <Input
                          type="select"
                          value={selectedFamilia}
                          required
                          onChange={(e) => {
                            setSelectedFamilia(e.target.value);
                          }}
                          style={{ width: "100%" }}
                        >
                          <option value="0">Selecciona una Familia</option>
                          {familias
                            .sort((a, b) => (a.name > b.name ? 1 : -1))
                            .map((a) => {
                              return <option key={a._id} value={a._id}>{a.name}</option>;
                            })}
                        </Input>
                      </div>
                      <Button
                        color="success"
                        size="sm"
                        type="button"
                        style={{
                          marginLeft: "10px",
                          borderRadius: "4px",
                          padding: "6px 10px",
                        }}
                        onClick={() => {
                          setIsAddingFamilia(true);
                        }}
                      >
                        <i className="fas fa-plus"></i>
                      </Button>
                    </>
                  ) : (
                    <>
                      <div style={{ width: "calc(100% - 40px)" }}>
                        <Input
                          type="text"
                          value={newFamiliaName}
                          required
                          placeholder="Nueva Familia"
                          onChange={(e) => {
                            setNewFamiliaName(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && newFamiliaName.trim()) {
                              setIsAddingFamilia(false);
                            }
                          }}
                          style={{ width: "100%" }}
                        />
                      </div>
                      <Button
                        color="secondary"
                        size="sm"
                        type="button"
                        style={{
                          marginLeft: "10px",
                          borderRadius: "4px",
                          padding: "6px 10px",
                        }}
                        onClick={() => {
                          setIsAddingFamilia(false);
                          setNewFamiliaName("");
                        }}
                      >
                        <i className="fas fa-times"></i>
                      </Button>
                    </>
                  )}
                </div>
              </Col>
            </Row>
            <Row>
              {/* Coleccion */}
              <Col md={3} className="mb-3">
                <Label className="mr-sm-2">Coleccion</Label>
                <div className="d-flex align-items-center">
                  {!isAddingColeccion ? (
                    <>
                      <div style={{ width: "calc(100% - 40px)" }}>
                        <Input
                          type="select"
                          value={selectedColeccion}
                          required
                          onChange={(e) => {
                            setSelectedColeccion(e.target.value);
                          }}
                          style={{ width: "100%" }}
                        >
                          <option value="0">Selecciona una Coleccion</option>
                          {colecciones
                            .sort((a, b) => (a.name > b.name ? 1 : -1))
                            .map((a) => {
                              return <option key={a._id} value={a._id}>{a.name}</option>;
                            })}
                        </Input>
                      </div>
                      <Button
                        color="success"
                        size="sm"
                        type="button"
                        style={{
                          marginLeft: "10px",
                          borderRadius: "4px",
                          padding: "6px 10px",
                        }}
                        onClick={() => {
                          setIsAddingColeccion(true);
                        }}
                      >
                        <i className="fas fa-plus"></i>
                      </Button>
                    </>
                  ) : (
                    <>
                      <div style={{ width: "calc(100% - 40px)" }}>
                        <Input
                          type="text"
                          value={newColeccionName}
                          required
                          placeholder="Nueva Coleccion"
                          onChange={(e) => {
                            setNewColeccionName(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && newColeccionName.trim()) {
                              setIsAddingColeccion(false);
                            }
                          }}
                          style={{ width: "100%" }}
                        />
                      </div>
                      <Button
                        color="secondary"
                        size="sm"
                        type="button"
                        style={{
                          marginLeft: "10px",
                          borderRadius: "4px",
                          padding: "6px 10px",
                        }}
                        onClick={() => {
                          setIsAddingColeccion(false);
                          setNewColeccionName("");
                        }}
                      >
                        <i className="fas fa-times"></i>
                      </Button>
                    </>
                  )}
                </div>
              </Col>

              {/* Año */}
              <Col md={3} className="mb-3">
                <Label>Año</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={ano}
                  required
                  onChange={(e) => {
                    setAno(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un Año</option>
                  {years.map((a) => {
                    return <option key={a} value={a}>{a}</option>;
                  })}
                </Input>
              </Col>

              {/* Proveedor */}
              <Col md={3} className="mb-3">
                <Label className="mr-sm-2">Proveedor</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedProveedor}
                  required
                  onChange={(e) => {
                    setSelectedProveedor(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un Proveedor</option>
                  {proveedores
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option key={a._id} value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </Col>
            </Row>
            <h4>Precios de Venta</h4>
            <Row>
              <Col md={3}>
                <Label>Lista Pieza</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={listaPrecioPieza}
                  required
                  onChange={(e) => {
                    setListaPrecioPieza(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Lista Corrida</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={listaPrecioCorrida}
                  required
                  onChange={(e) => {
                    setListaPrecioCorrida(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Lista Paquete</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={listaPrecioPaquete}
                  required
                  onChange={(e) => {
                    setListaPrecioPaquete(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Lista Caja</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={listaPrecioCaja}
                  required
                  onChange={(e) => {
                    setListaPrecioCaja(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Lista Rebajas</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={listaPrecioRebajas}
                  required
                  onChange={(e) => {
                    setListaPrecioRebajas(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Agregar Colores
                </Label>
                <br />
                <Button
                  color="success"
                  id="Colores"
                  type="button"
                  onClick={(e) => toggleColores()}
                >
                  <i className="fas fa-palette fa-2x "></i>
                </Button>
              </Col>

              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Agregar Tallas
                </Label>
                <br />
                <Button
                  color="success"
                  id="Tallas"
                  type="button"
                  onClick={(e) => toggleTallas()}
                >
                  <i className="fas fa-ruler-horizontal fa-2x "></i>
                </Button>
              </Col>

              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Agregar Foto
                </Label>
                <br />
                <Button
                  color="info"
                  id="Foto"
                  type="button"
                  onClick={() => toggleFoto()}
                >
                  <i className="fas fa-camera fa-2x "></i>
                </Button>
              </Col>
            </Row>

            {/* Photo Preview Section */}
            {photoPreview && (
              <Row className="mt-3">
                <Col md={12}>
                  <Label>Vista previa de la foto:</Label>
                  <div style={{ textAlign: "center", marginTop: "10px" }}>
                    <img
                      src={photoPreview}
                      alt="Vista previa"
                      style={{
                        maxWidth: "300px",
                        maxHeight: "200px",
                        border: "1px solid #ddd",
                        borderRadius: "5px",
                      }}
                    />
                    <br />
                    <small className="text-muted d-block">
                      Archivo: {file?.name}
                    </small>
                    <Button
                      color="danger"
                      size="sm"
                      type="button"
                      onClick={clearPhoto}
                      className="mt-2"
                    >
                      <i className="fas fa-trash"></i> Quitar Foto
                    </Button>
                  </div>
                </Col>
              </Row>
            )}
            <br />
            <Row className="w-full">
              <div className="bg-white shadow-md rounded-lg overflow-hidden border border-gray-200 w-full">
                <div className="p-6 bg-gray-50">
                  <Label className="text-xl font-semibold text-gray-800 mb-4 block">
                    Proporcion
                  </Label>

                  {/* Enhanced scrollable container */}
                  <div
                    style={{
                      width: "100%",
                      overflowX: "auto",
                      WebkitOverflowScrolling: "touch",
                      display: "block",
                      maxWidth: "100%",
                    }}
                  >
                    <table
                      style={{
                        minWidth: "1200px",
                        width: "100%",
                        borderCollapse: "collapse",
                      }}
                    >
                      <thead>
                        {/* Size Names Row */}
                        <tr>
                          <th
                            className="border py-3 px-4 text-center font-medium text-gray-600"
                            style={{
                              width: "200px",
                              position: "sticky",
                              left: 0,
                              zIndex: 10,
                              backgroundColor: "white",
                              color: "gray",
                            }}
                          ></th>
                          {[...arrayTallas]
                            .sort((a, b) => {
                              const indexA = customSizeOrder.indexOf(a.name);
                              const indexB = customSizeOrder.indexOf(b.name);
                              if (indexA === -1 && indexB === -1) return 0;
                              if (indexA === -1) return 1;
                              if (indexB === -1) return -1;
                              return indexA - indexB;
                            })
                            .map((size) => (
                              <th
                                key={size.id}
                                className="border py-2 px-4 text-center font-medium text-gray-600"
                                colSpan="2"
                              >
                                <div
                                  className="text-lg border border-gray-300 rounded-t-lg py-2 bg-gray-100"
                                  style={{ color: "gray" }}
                                >
                                  {size.name}
                                </div>
                              </th>
                            ))}
                        </tr>

                        {/* Column Headers Row */}
                        <tr>
                          <th
                            className="border py-2 px-4 text-left font-medium text-gray-500"
                            style={{
                              position: "sticky",
                              left: 0,
                              zIndex: 10,
                              backgroundColor: "white",
                              color: "gray",
                            }}
                          ></th>
                          {[...arrayTallas]
                            .sort((a, b) => {
                              const indexA = customSizeOrder.indexOf(a.name);
                              const indexB = customSizeOrder.indexOf(b.name);
                              if (indexA === -1 && indexB === -1) return 0;
                              if (indexA === -1) return 1;
                              if (indexB === -1) return -1;
                              return indexA - indexB;
                            })
                            .map((size) => (
                              <React.Fragment key={`header-${size.id}`}>
                                <th
                                  className="border py-2 px-1 text-center text-xs font-medium text-gray-500 bg-gray-50"
                                  style={{
                                    width: "80px",
                                    color: "gray",
                                  }}
                                >
                                  CANTIDAD
                                </th>
                                <th
                                  className="border py-2 px-3 text-center text-xs font-medium text-gray-500 bg-gray-50"
                                  style={{
                                    width: "240px",
                                    color: "gray",
                                  }}
                                >
                                  CÓDIGO DE BARRAS
                                </th>
                              </React.Fragment>
                            ))}
                        </tr>
                      </thead>
                      <tbody>
                        {arrayColores.map((color, colorIndex) => (
                          <tr
                            key={color.id}
                            className={`${
                              colorIndex % 2 === 0 ? "bg-white" : "bg-gray-50"
                            } hover:bg-gray-100 transition-colors`}
                          >
                            <td
                              className="border py-3 px-4 text-gray-700 font-medium"
                              style={{
                                position: "sticky",
                                left: 0,
                                zIndex: 5,
                                backgroundColor:
                                  colorIndex % 2 === 0 ? "white" : "#f9fafb",
                                color: "gray",
                              }}
                            >
                              <div className="flex items-center">
                                <div
                                  className="w-4 h-4 rounded-full mr-3"
                                  style={{
                                    backgroundColor: color.name.toLowerCase(),
                                    color: "gray",
                                  }}
                                ></div>
                                <span className="uppercase">{color.name}</span>
                              </div>
                            </td>
                            {[...arrayTallas]
                              .sort((a, b) => {
                                const indexA = customSizeOrder.indexOf(a.name);
                                const indexB = customSizeOrder.indexOf(b.name);
                                if (indexA === -1 && indexB === -1) return 0;
                                if (indexA === -1) return 1;
                                if (indexB === -1) return -1;
                                return indexA - indexB;
                              })
                              .map((size) => {
                                const entry = amounts.find(
                                  (entry) =>
                                    entry.sizeId === size.id &&
                                    entry.colorId === color.id
                                );
                                const cantidad = entry?.cantidad || 0;
                                const ean = entry?.ean || "";

                                return (
                                  <React.Fragment
                                    key={`${color.id}-${size.id}`}
                                  >
                                    <td className="border py-2 px-1 text-center">
                                      <input
                                        type="number"
                                        min="0"
                                        step="any"
                                        value={cantidad}
                                        onChange={(e) =>
                                          handleInputChange(
                                            size.id,
                                            color.id,
                                            e.target.value,
                                            "amount"
                                          )
                                        }
                                        className="w-full border border-gray-300 rounded-lg p-2 text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="0"
                                      />
                                    </td>
                                    <td className="border py-2 px-3 text-center">
                                      <input
                                        type="text"
                                        value={ean}
                                        onChange={(e) =>
                                          handleInputChange(
                                            size.id,
                                            color.id,
                                            e.target.value,
                                            "ean"
                                          )
                                        }
                                        className="w-full border border-gray-300 rounded-lg p-2 text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        
                                      />
                                    </td>
                                  </React.Fragment>
                                );
                              })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </Row>
            <br />
            {validaBoton &&
            arrayColores.length > 0 &&
            arrayTallas.length > 0 &&
            amounts.some((entry) => entry.cantidad > 0) ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoArticulos"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />

          <Modal size="lg" isOpen={modalColores} toggle={toggleColores}>
            <ModalHeader toggle={toggleColores}>
              <h4>Colores del Modelo {nombre}</h4>
            </ModalHeader>
            <ModalBody>
              {/* Show available colores (unchecked) */}
              {colores
                .filter(
                  (color) =>
                    !arrayColores.some((selected) => selected.id === color._id)
                )
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((a) => {
                  return (
                    <table key={a._id}>
                      <tbody>
                        <tr>
                          <td>
                            <Input
                              type="checkbox"
                              key={a._id}
                              onChange={(e) => {
                                coloresSeleccionados(
                                  e.currentTarget.checked,
                                  a
                                );
                              }}
                              className="subMenu"
                            />
                            <h5 className="subMenuTitulo">{a.name}</h5>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  );
                })}

              {/* Show selected colores at the bottom */}
              {arrayColores.length > 0 && (
                <>
                  <hr style={{ margin: "20px 0" }} />
                  <h6 style={{ fontWeight: "bold" }}>Colores Seleccionados:</h6>
                  {arrayColores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((selectedColor) => (
                      <table key={`selected-${selectedColor.id}`}>
                        <tbody>
                          <tr>
                            <td>
                              <Input
                                type="checkbox"
                                checked={true}
                                onChange={(e) => {
                                  coloresSeleccionados(
                                    e.currentTarget.checked,
                                    selectedColor
                                  );
                                }}
                                className="subMenu"
                              />
                              <h5 className="subMenuTitulo">
                                {selectedColor.name}
                              </h5>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    ))}
                </>
              )}
            </ModalBody>
          </Modal>

          <Modal size="lg" isOpen={modalTallas} toggle={toggleTallas}>
            <ModalHeader toggle={toggleTallas}>
              <h4>Tallas del Modelo {nombre}</h4>
            </ModalHeader>
            <ModalBody>
              {/* Show available tallas (unchecked) */}
              {tallas
                .filter(
                  (talla) =>
                    !arrayTallas.some((selected) => selected.id === talla._id)
                )
                .sort((a, b) => {
                  const indexA = customSizeOrder.indexOf(a.name);
                  const indexB = customSizeOrder.indexOf(b.name);

                  if (indexA === -1 && indexB === -1) return 0;
                  if (indexA === -1) return 1;
                  if (indexB === -1) return -1;

                  return indexA - indexB;
                })
                .map((a) => {
                  return (
                    <table key={a._id}>
                      <tbody>
                        <tr>
                          <td>
                            <Input
                              type="checkbox"
                              key={a._id}
                              onChange={(e) => {
                                tallasSeleccionados(e.currentTarget.checked, a);
                              }}
                              className="subMenu"
                            />
                            <h5 className="subMenuTitulo">{a.name}</h5>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  );
                })}

              {/* Show selected tallas at the bottom */}
              {arrayTallas.length > 0 && (
                <>
                  <hr style={{ margin: "20px 0" }} />
                  <h6 style={{ fontWeight: "bold" }}>Tallas Seleccionadas:</h6>
                  {arrayTallas
                    .sort((a, b) => {
                      const indexA = customSizeOrder.indexOf(a.name);
                      const indexB = customSizeOrder.indexOf(b.name);

                      if (indexA === -1 && indexB === -1) return 0;
                      if (indexA === -1) return 1;
                      if (indexB === -1) return -1;

                      return indexA - indexB;
                    })
                    .map((selectedTalla) => (
                      <table key={`selected-${selectedTalla.id}`}>
                        <tbody>
                          <tr>
                            <td>
                              <Input
                                type="checkbox"
                                checked={true}
                                onChange={(e) => {
                                  tallasSeleccionados(
                                    e.currentTarget.checked,
                                    selectedTalla
                                  );
                                }}
                                className="subMenu"
                              />
                              <h5 className="subMenuTitulo">
                                {selectedTalla.name}
                              </h5>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    ))}
                </>
              )}
            </ModalBody>
          </Modal>

          {/* Photo Upload Modal */}
          <Modal size="md" isOpen={modalFoto} toggle={toggleFoto}>
            <ModalHeader toggle={toggleFoto}>
              <h4>{photoPreview ? "Cambiar Foto del Artículo" : "Agregar Foto del Artículo"}</h4>
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <p><strong>Artículo:</strong> {codigo} - {nombre}</p>
                  <hr />
                </Col>

                <Col md={12}>
                  <Row>
                    <Col md={12}>
                      <Label>{photoPreview ? "Cambiar Foto" : "Seleccionar Foto"}</Label>
                      <Input
                        type="file"
                        accept="image/*"
                        onChange={handleFileSelect}
                      />
                      {file && (
                        <small className="text-muted d-block mt-2">
                          Archivo seleccionado: {file.name}
                        </small>
                      )}
                      <small className="text-info d-block mt-2">
                        Formatos permitidos: JPG, PNG, GIF. Tamaño máximo: 5MB
                      </small>
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col md={6}>
                      <Button
                        color="success"
                        onClick={toggleFoto}
                        disabled={!file}
                        block
                      >
                        {photoPreview ? "Actualizar" : "Agregar"}
                      </Button>
                    </Col>
                    <Col md={6}>
                      {photoPreview ? (
                        <Button
                          color="danger"
                          onClick={() => {
                            clearPhoto();
                            toggleFoto();
                          }}
                          block
                        >
                          Quitar Foto
                        </Button>
                      ) : (
                        <Button
                          color="secondary"
                          onClick={toggleFoto}
                          block
                        >
                          Cancelar
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default ArticulosCreate;